import React, { useEffect, useRef } from "react";

export default function Log({ log }) {
  const logEndRef = useRef(null);

  useEffect(() => {
    if (logEndRef.current) logEndRef.current.scrollIntoView({ behavior: "smooth" });
  }, [log]);

  return (
    <div style={{ height: "100%", border: "2px solid #333", borderRadius: "6px", padding: "10px", background: "#1a1a1a", overflow: "auto" }}>
      <h3>Log</h3>
      <div style={{ fontFamily: "monospace", whiteSpace: "pre-wrap", fontSize: "14px" }}>
        {log.map((entry, index) => (
          <div key={index} style={{ color: "#6A9955" }}>
            {entry === "" ? <br /> : <>• {entry}</>}
          </div>
        ))}
        <div ref={logEndRef} />
      </div>
    </div>
  );
}
